module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'analysis/base' && templateVars.config ?
				templateVars.config :
				{
	"config": {
		"colors": [
			"#ce1126",
			"#ed694b",
			"#f48978",
			"#616365",
			"#939499",
			"#e4e4e4",
			"#f2f2f2",
			"#ff9896",
			"#9467bd",
			"#c5b0d5",
			"#8c564b",
			"#c49c94",
			"#e377c2",
			"#f7b6d2",
			"#7f7f7f",
			"#c7c7c7",
			"#bcbd22",
			"#dbdb8d",
			"#17becf"
		],
		"selectionMaximum": 7,
		"size": {
			"height": 350,
			"width": 530
		}
	},
	"data": {
		"presets": [],
		"years": [
			2016,
			2017,
			2018,
			2019
		],
		"units": {
			"млрд руб.": {
				"ru": "млрд руб.",
				"en": "RUB billion"
			},
			"тыс. контрактов": {
				"ru": "тыс. контрактов",
				"en": "contracts ths."
			}
		},
		"groups": [
			{
				"id": 1,
				"title": {
					"ru": "Рынок акций",
					"en": "Equity Market"
				},
				"items": [
					{
						"id": 1,
						"title": {
							"ru": "Объемы торгов на рынке акций",
							"en": "Equity Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							9277,
							9185,
							10830,
							12443
						]
					}
				]
			},
			{
				"id": 2,
				"title": {
					"ru": "Рынок облигаций",
					"en": "Bond Market"
				},
				"items": [
					{
						"id": 2,
						"title": {
							"ru": "Объемы торгов на рынке облигаций",
							"en": "Bond Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							14616,
							26228,
							29841,
							28219
						]
					},
					{
						"id": 3,
						"title": {
							"ru": "Вторичные торги",
							"en": "Secondary trading"
						},
						"units": "млрд руб.",
						"values": [
							9589,
							10979,
							10219,
							10631
						],
						"className": "group-1"
					},
					{
						"id": 4,
						"title": {
							"ru": "ОФЗ",
							"en": "Sovereign bonds (OFZ)"
						},
						"units": "млрд руб.",
						"values": [
							4961,
							6470,
							6538,
							6781
						],
						"className": "subgroup"
					},
					{
						"id": 5,
						"title": {
							"ru": "ОБР",
							"en": "Bank of Russia bonds (OBR)"
						},
						"units": "млрд руб.",
						"values": [
							null,
							101,
							537,
							411
						],
						"className": "subgroup"
					},
					{
						"id": 6,
						"title": {
							"ru": "Субфедеральные и муниципальные",
							"en": "Municipal bonds"
						},
						"units": "млрд руб.",
						"values": [
							398,
							337,
							274,
							176
						],
						"className": "subgroup"
					},
					{
						"id": 7,
						"title": {
							"ru": "Корпоративные",
							"en": "Corporate bonds"
						},
						"units": "млрд руб.",
						"values": [
							4135,
							3928,
							2767,
							3109
						],
						"className": "subgroup"
					},
					{
						"id": 8,
						"title": {
							"ru": "Прочие (еврооблигации, облигации МФО и иностранных государств)",
							"en": "Other"
						},
						"units": "млрд руб.",
						"values": [
							95,
							143,
							102,
							155
						],
						"className": "subgroup"
					},
					{
						"id": 9,
						"title": {
							"ru": "Размещения и погашения",
							"en": "Primary market and bond redemptions"
						},
						"units": "млрд руб.",
						"values": [
							5027,
							15250,
							19622,
							17588
						],
						"className": "group-1"
					},
					{
						"id": 10,
						"title": {
							"ru": "ОФЗ",
							"en": "Sovereign bonds (OFZ)"
						},
						"units": "млрд руб.",
						"values": [
							1123,
							1715,
							1034,
							2061
						],
						"className": "subgroup"
					},
					{
						"id": 11,
						"title": {
							"ru": "ОБР",
							"en": "Bank of Russia bonds (OBR)"
						},
						"units": "млрд руб.",
						"values": [
							null,
							502,
							7017,
							6062
						],
						"className": "subgroup"
					},
					{
						"id": 12,
						"title": {
							"ru": "Субфедеральные и муниципальные",
							"en": "Municipal bonds"
						},
						"units": "млрд руб.",
						"values": [
							159,
							214,
							86,
							112
						],
						"className": "subgroup"
					},
					{
						"id": 13,
						"title": {
							"ru": "Корпоративные",
							"en": "Corporate bonds"
						},
						"units": "млрд руб.",
						"values": [
							2342,
							3148,
							2850,
							3483
						],
						"className": "subgroup"
					},
					{
						"id": 14,
						"title": {
							"ru": "Однодневные",
							"en": "One-day bonds"
						},
						"units": "млрд руб.",
						"values": [
							1401,
							9665,
							8625,
							5859
						],
						"className": "subgroup"
					},
					{
						"id": 15,
						"title": {
							"ru": "Прочие (еврооблигации, облигации МФО и иностранных государств)",
							"en": "Other"
						},
						"units": "млрд руб.",
						"values": [
							2,
							6,
							10,
							14
						],
						"className": "subgroup"
					}
				]
			},
			{
				"id": 3,
				"title": {
					"ru": "Срочный рынок",
					"en": "Derivatives Market"
				},
				"items": [
					{
						"id": 16,
						"title": {
							"ru": "Объемы торгов на срочном рынке",
							"en": "Derivatives Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							115271,
							84497,
							89263,
							82370
						],
						"className": "group-1"
					},
					{
						"id": 17,
						"title": {
							"ru": "Фьючерсы",
							"en": "Futures"
						},
						"units": "млрд руб.",
						"values": [
							109489,
							77624,
							82397,
							77376
						],
						"className": "subgroup"
					},
					{
						"id": 18,
						"title": {
							"ru": "Опционы",
							"en": "Options"
						},
						"units": "млрд руб.",
						"values": [
							5782,
							6873,
							6866,
							4994
						],
						"className": "subgroup"
					},
					{
						"id": 19,
						"title": {
							"ru": "Фьючерсы",
							"en": "Futures"
						},
						"units": "млрд руб.",
						"values": [
							109489,
							77624,
							82397,
							77376
						],
						"className": "group-1"
					},
					{
						"id": 20,
						"title": {
							"ru": "валютные",
							"en": "FX"
						},
						"units": "млрд руб.",
						"values": [
							64561,
							39460,
							37868,
							28996
						],
						"className": "subgroup"
					},
					{
						"id": 21,
						"title": {
							"ru": "процентные",
							"en": "Interest rates"
						},
						"units": "млрд руб.",
						"values": [
							27,
							17,
							10,
							12
						],
						"className": "subgroup"
					},
					{
						"id": 22,
						"title": {
							"ru": "фондовые",
							"en": "Single stock"
						},
						"units": "млрд руб.",
						"values": [
							3529,
							3383,
							4439,
							4345
						],
						"className": "subgroup"
					},
					{
						"id": 23,
						"title": {
							"ru": "индексные",
							"en": "Indices"
						},
						"units": "млрд руб.",
						"values": [
							26138,
							18486,
							19161,
							16504
						],
						"className": "subgroup"
					},
					{
						"id": 24,
						"title": {
							"ru": "товарные",
							"en": "Commodities"
						},
						"units": "млрд руб.",
						"values": [
							15234,
							16278,
							20918,
							27519
						],
						"className": "subgroup"
					},
					{
						"id": 25,
						"title": {
							"ru": "Опционы",
							"en": "Options"
						},
						"units": "млрд руб.",
						"values": [
							5782,
							6873,
							6866,
							4994
						],
						"className": "group-1"
					},
					{
						"id": 26,
						"title": {
							"ru": "валютные",
							"en": "FX"
						},
						"units": "млрд руб.",
						"values": [
							2119,
							2184,
							2047,
							1478
						],
						"className": "subgroup"
					},
					{
						"id": 27,
						"title": {
							"ru": "фондовые",
							"en": "Single stock"
						},
						"units": "млрд руб.",
						"values": [
							87,
							35,
							25,
							51
						],
						"className": "subgroup"
					},
					{
						"id": 28,
						"title": {
							"ru": "индексные",
							"en": "Indices"
						},
						"units": "млрд руб.",
						"values": [
							3434,
							4440,
							4438,
							3107
						],
						"className": "subgroup"
					},
					{
						"id": 29,
						"title": {
							"ru": "товарные",
							"en": "Commodities"
						},
						"units": "млрд руб.",
						"values": [
							142,
							213,
							356,
							358
						],
						"className": "subgroup"
					}
				]
			},
			{
				"id": 4,
				"title": {
					"ru": "Валютный рынок",
					"en": "FX market"
				},
				"items": [
					{
						"id": 30,
						"title": {
							"ru": "Объемы торгов на валютном рынке",
							"en": "FX Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							329954,
							347671,
							348368,
							308274
						],
						"className": "group-1"
					},
					{
						"id": 31,
						"title": {
							"ru": "Спот",
							"en": "Spot"
						},
						"units": "млрд руб.",
						"values": [
							107169,
							78380,
							86682,
							67370
						],
						"className": "subgroup"
					},
					{
						"id": 32,
						"title": {
							"ru": "Своп и форварды",
							"en": "Swaps and forwards"
						},
						"units": "млрд руб.",
						"values": [
							222785,
							269291,
							261686,
							240904
						],
						"className": "subgroup"
					},
					{
						"id": 33,
						"title": {
							"ru": "Валютные пары",
							"en": "Currency pairs"
						},
						"units": "млрд руб.",
						"className": "group-1"
					},
					{
						"id": 34,
						"title": {
							"ru": "Доллар США - российский рубль",
							"en": "USD – RUB"
						},
						"units": "млрд руб.",
						"values": [
							278334,
							285962,
							277751,
							242627
						],
						"className": "subgroup"
					},
					{
						"id": 35,
						"title": {
							"ru": "Евро - российский рубль",
							"en": "EUR – RUB"
						},
						"units": "млрд руб.",
						"values": [
							43065,
							48231,
							59243,
							51571
						],
						"className": "subgroup"
					},
					{
						"id": 36,
						"title": {
							"ru": "Евро - доллар США",
							"en": "EUR – USD"
						},
						"units": "млрд руб.",
						"values": [
							7669,
							12869,
							10084,
							13349
						],
						"className": "subgroup"
					},
					{
						"id": 37,
						"title": {
							"ru": "Юань - российский рубль",
							"en": "CNY – RUB"
						},
						"units": "млрд руб.",
						"values": [
							776,
							492,
							1081,
							551
						],
						"className": "subgroup"
					},
					{
						"id": 38,
						"title": {
							"ru": "Прочие",
							"en": "Other"
						},
						"units": "млрд руб.",
						"values": [
							110,
							117,
							209,
							176
						],
						"className": "subgroup"
					}
				]
			},
			{
				"id": 5,
				"title": {
					"ru": "Денежный рынок",
					"en": "Money Market"
				},
				"items": [
					{
						"id": 39,
						"title": {
							"ru": "Объемы торгов на денежном рынке",
							"en": "Money Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							333883,
							377141,
							364216,
							346347
						],
						"className": "group-1"
					},
					{
						"id": 40,
						"title": {
							"ru": "Операции РЕПО на бирже",
							"en": "On-exchange repo"
						},
						"units": "млрд руб.",
						"values": [
							296226,
							339509,
							309913,
							292813
						],
						"className": "group-1"
					},
					{
						"id": 41,
						"title": {
							"ru": "Прямое РЕПО с Банком России",
							"en": "Direct repo with the Bank of Russia"
						},
						"units": "млрд руб.",
						"values": [
							54662,
							35575,
							829,
							274
						],
						"className": "subgroup"
					},
					{
						"id": 42,
						"title": {
							"ru": "Междилерское РЕПО",
							"en": "Interdealer repo"
						},
						"units": "млрд руб.",
						"values": [
							65393,
							72397,
							49663,
							36441
						],
						"className": "subgroup"
					},
					{
						"id": 43,
						"title": {
							"ru": "РЕПО с ЦК",
							"en": "CCP-cleared repo"
						},
						"units": "млрд руб.",
						"values": [
							176171,
							231537,
							259421,
							256075
						],
						"className": "subgroup"
					},
					{
						"id": 44,
						"title": {
							"ru": "в т.ч. РЕПО с ЦК с КСУ",
							"en": "including GCC-repo"
						},
						"units": "млрд руб.",
						"values": [
							324,
							6170,
							46888,
							54054
						],
						"className": "subgroup-2"
					},
					{
						"id": 45,
						"title": {
							"ru": "Кредитный рынок",
							"en": "Credit market"
						},
						"units": "млрд руб.",
						"values": [
							37657,
							37631,
							54303,
							53534
						],
						"className": "group-1"
					}
				]
			},
			{
				"id": 6,
				"title": {
					"ru": "Товарный рынок",
					"en": "Commodities market"
				},
				"items": [
					{
						"id": 46,
						"title": {
							"ru": "Объемы торгов на рынке драгоценных металлов",
							"en": "Precious Metals Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							125,
							122,
							102,
							35
						],
						"className": "group-1"
					},
					{
						"id": 47,
						"title": {
							"ru": "Объемы торгов на рынке зерна и сахара",
							"en": "Grain and Sugar Market trading volumes"
						},
						"units": "млрд руб.",
						"values": [
							12,
							6,
							50,
							50
						],
						"className": "group-1"
					},
					{
						"id": 48,
						"title": {
							"ru": "Зерно",
							"en": "Grain"
						},
						"units": "млрд руб.",
						"values": [
							12,
							5,
							46,
							46
						],
						"className": "subgroup"
					},
					{
						"id": 49,
						"title": {
							"ru": "Сахар",
							"en": "Sugar"
						},
						"units": "млрд руб.",
						"values": [
							null,
							0.5,
							4,
							4
						],
						"className": "subgroup"
					}
				]
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/analysis/.variant/base/config.yaml
// module id = 69
// module chunks = 0